export const LOGIN_LINE = `על מנת לצפות בנתונים לפי חדרים/שכונות/חודשים אחרים - `
export const LOGIN_LINK_SPAN = `יש להכנס למערכת`